export const parseBooleanEnv = (value: string | undefined): boolean =>
  value?.trim().toLowerCase() === "true";
